/** GraphQL selection for a single step configuration. */
export const PHOTO_TYPE_STEP_CONFIG_QUERY = `
  enabled
  required
  minPhotos
  maxPhotos
`;
